import { render, staticRenderFns } from "./FlagModal.vue?vue&type=template&id=03843a77&"
import script from "./FlagModal.vue?vue&type=script&lang=js&"
export * from "./FlagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports